import styled from 'styled-components';
import Wra16D from 'dc/Wra16D';

export const Wrapper = styled(Wra16D)`
  background: #f4f7f9;
  width: 100%;
`;
